import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import {
  addPaymentMethod,
  loadFinanceExpenses,
  loadFinanceOverview,
  recharge,
  selectSubscription,
  setFinanceExpensesData,
  setFinanceExpensesHasMorePage,
  setFinanceExpensesPageIndex,
  setFinanceOverviewState,
  trialActivate
} from '@adex/store/actions/finance.actions'
import { map, mergeMap, observeOn, switchMap, withLatestFrom } from 'rxjs/operators'
import { FinanceNetworkService } from '@adex/store/services/finance-network.service'
import { catchErrorAlert } from '@adex/shared/utils/errors'
import { Store } from '@ngrx/store'
import { selectFinanceExpensesTablePagination } from '@adex/store/selectors'
import { asapScheduler } from 'rxjs'
import { navigate } from '@adex/store/actions'
import { appRoutes } from '@adex/shared/routing/routes'
import { XorService } from '@adex/shared/services/xor.service'


@Injectable()
export class FinanceEffects {

  public readonly loadFinanceOverview$ = createEffect(() => this.actions$.pipe(
    ofType(loadFinanceOverview),
    switchMap(() => this.network.getFinanceOverview().pipe(
      map(state => setFinanceOverviewState({ state })),
      catchErrorAlert()
    ))
  ))

  public readonly loadFinanceExpenses$ = createEffect(() => this.actions$.pipe(
    ofType(loadFinanceExpenses),
    withLatestFrom(this.store.select(selectFinanceExpensesTablePagination)),
    switchMap(([ _, p ]) => this.network.getFinanceExpenses(p).pipe(
      mergeMap(({ data, pagination }) => [
        setFinanceExpensesData({ data }),
        setFinanceExpensesHasMorePage({ hasMore: pagination.hasMore })
      ]),
      catchErrorAlert()
    ))
  ))

  public readonly selectSubscription$ = createEffect(() => this.actions$.pipe(
    ofType(selectSubscription),
    switchMap(({ id }) => this.network.selectSubscription(id).pipe(
      map(({ url }) => this.xor.encode(url)),
      map((url) => navigate({ commands: appRoutes.app.frame, extras: { queryParams: { url } } })),
      catchErrorAlert()
    ))
  ))

  public readonly trialActivate$ = createEffect(() => this.actions$.pipe(
    ofType(trialActivate),
    switchMap(({ subscriptionType, successUrl, failUrl }) => this.network.trialActivate(subscriptionType, successUrl, failUrl).pipe(
      map(({ url }) => this.xor.encode(url)),
      map((url) => navigate({ commands: appRoutes.app.frame, extras: { queryParams: { url } } })),
      catchErrorAlert()
    ))
  ))

  public readonly addPaymentMethod$ = createEffect(() => this.actions$.pipe(
    ofType(addPaymentMethod),
    switchMap(({ successUrl, failUrl }) => this.network.addPaymentMethod(successUrl, failUrl).pipe(
      // map(({ url }) => this.xor.encode(url)),
      map(({url}) => {location.href = url; return {errors:[], url: url}}/* navigate({ commands: appRoutes.app.frame, extras: { queryParams: { url } } })*/),
      catchErrorAlert()
    ))
  ))

  public readonly updateFinanceExpenses$ = createEffect(() => this.actions$.pipe(
    ofType(
      setFinanceExpensesPageIndex
    ),
    observeOn(asapScheduler),
    map(() => loadFinanceExpenses())
  ))

  public readonly recharge$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(recharge),
      switchMap(({ amount }) => this.network.recharge(amount).pipe(
        map(({ url }) => this.xor.encode(url)),
        map((url) => navigate({ commands: appRoutes.app.frame, extras: { queryParams: { url } } })),
        catchErrorAlert()
      ))
    )
  })

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly network: FinanceNetworkService,
    private readonly xor: XorService
  ) {
  }

}
